import styled from "styled-components";
import { useState, useEffect } from "react";
import FormStringInput from "../../../../components/FormControls/FormStringInput";
import FormStringTextArea from "../../../../components/FormControls/FormStringTextArea";
import FormDatePicker from "../../../../components/FormControls/FormDatePicker";
import FormCheckBoxWithRightLabel from "../../../../components/FormControls/FormCheckBoxWithRightLabel";
import PrimaryButton from "../../../../components/FormControls/PrimaryButton";
import request from "../../../../api/request";
import NotificationManager from "react-notifications/lib/NotificationManager";

const StyledMessageDetails = styled.div`
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 100%;
    box-sizing: border-box;
    min-height: 490px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

function MessageDetails(props) {

    const {messages, selectedMessage, isAddMode, setIsAddMode, refreshMessagesCallback} = props;

    const [timer, setTimer] = useState(null);
    const [loadedPage, setLoadedPage] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [messageDate, setMessageDate] = useState('');
    const [expireOnDate, setExpireOnDate] = useState(null);
    const [expireOnTime, setExpireOnTime] = useState('00:00');
    const [message, setMessage] = useState('PLEASE NOTE: Some hare having issues with entering transactions, we are aware and its being looked into, please bear with us while we get these issues resolved.');
    const [displayAfterLogOn, setDisplayAfterLogOn] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [showLinkToHelp, setShowLinkToHelp] = useState(false);
    
    const [needsValidation, setNeedsValidation] = useState(false);

    const convertDateToUTCTimeZone = (val) => {
        let diffMinutes = val.getTimezoneOffset();
        val.setTime(val.getTime() - diffMinutes*60*1000);
        return val;
    }
    
    const dateToStr = (date) => {
        function pad(s) { return (s < 10) ? '0' + s : s; };
        let ret = [pad(date.getDate()), pad(date.getMonth()+1), date.getFullYear()].join('/') + " " + [pad(date.getHours()), pad(date.getMinutes()), pad(date.getSeconds())].join(':');
        return ret;
    }

    const strToDate = (str) => {
        var date_components = str.split("/");
        var day = date_components[0];
        var month = date_components[1];
        var year = date_components[2];
        return new Date(year, month - 1, day);
    }

    function generateGUID() {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        ).toUpperCase();
    }

    const onSaveChanges = async () => {
        if (isAddMode) { // adding new item
            if (message === '' || expireOnDate === null || expireOnTime === '' || !expireOnTime.includes(":")) {
                setNeedsValidation(true);
            } else {
                setIsSaving(true);
                let saveData = {};
                saveData.MessageDate = new Date();
                saveData.Message = message;
                let expireDate = new Date(expireOnDate);
                let time = expireOnTime.split(":");
                expireDate.setHours(time[0]);
                expireDate.setMinutes(time[1]);
                expireDate.setSeconds(0);
                expireDate.setMilliseconds(0);
                saveData.ExpireOnDate = convertDateToUTCTimeZone(expireDate);
                saveData.CreatedByUser = props.user.UserName;
                saveData.DisplayAfterLogOn = displayAfterLogOn;
                saveData.IsActive = isActive;
                saveData.ShowLinkToHelp = showLinkToHelp;
                let messageId = generateGUID();
                saveData.MessageId = messageId;

                const resp = (await request('database', 'createMessage', [saveData]));
                if (resp.ok) {
                    NotificationManager.success('Successfully added message');
                    refreshMessagesCallback(messageId);
                } else
                {
                    console.log(resp.data);
                    NotificationManager.error(resp.data);
                }
                setIsSaving(false);
                setIsAddMode(false);
            }
        } else {
            if (message === '' || expireOnDate === null || expireOnTime === '' || !expireOnTime.includes(":")) {
                setNeedsValidation(true);
            } else {
                setIsSaving(true);
                let saveData = {};
                saveData.MessageDate = new Date();
                saveData.Message = message;
                let expireDate = new Date(expireOnDate);
                let time = expireOnTime.split(":");
                expireDate.setHours(time[0]);
                expireDate.setMinutes(time[1]);
                expireDate.setSeconds(0);
                expireDate.setMilliseconds(0);
                saveData.ExpireOnDate = convertDateToUTCTimeZone(expireDate);
                saveData.CreatedByUser = props.user.UserName;
                saveData.DisplayAfterLogOn = displayAfterLogOn;
                saveData.IsActive = isActive;
                saveData.ShowLinkToHelp = showLinkToHelp;
                let messageId = generateGUID();
                saveData.MessageId = messageId;
                saveData.OldMessageId = selectedMessage.MessageId;

                const resp = (await request('database', 'updateMessage', [saveData]));
                if (resp.ok) {
                    NotificationManager.success('Successfully added message');
                    refreshMessagesCallback(messageId);
                } else
                {
                    console.log(resp.data);
                    NotificationManager.error(resp.data);
                }
                setIsSaving(false);
                setIsAddMode(false);
            }
        }
    };

    function pad(s) { return (s < 10) ? '0' + s : s; };

    useEffect(() => {
        if (!loadedPage) {
            
            setLoadedPage(true);
        }
    }, [])

    useEffect(() => {
        if (selectedMessage) {
            setNeedsValidation(false);
            setMessageDate(dateToStr(new Date(selectedMessage.MessageDate)));
            setExpireOnDate(selectedMessage.ExpireOnDate ? selectedMessage.ExpireOnDate : null);
            let date = new Date(selectedMessage.ExpireOnDate);
            setExpireOnTime(selectedMessage.ExpireOnDate ? pad(date.getUTCHours()) + ":" + pad(date.getUTCMinutes()) : '00:00');
            setMessage(selectedMessage.Message);
            setDisplayAfterLogOn(selectedMessage.DisplayAfterLogOn);
            setIsActive(selectedMessage.IsActive);
            setShowLinkToHelp(selectedMessage.ShowLinkToHelp);
        } else {
            setExpireOnDate(new Date());
            setExpireOnTime('00:00');
            setMessage('');
            setDisplayAfterLogOn(false);
            setIsActive(true);
            setShowLinkToHelp(false);
        }
    }, [selectedMessage]);

    useEffect(() => {
        if (isAddMode) {
            setMessageDate(dateToStr(new Date()));
            setTimer(setInterval(() => {
                setMessageDate(dateToStr(new Date()));
            }, 1000));

            setNeedsValidation(false);
            setExpireOnDate(new Date());
            setExpireOnTime('00:00');
            setMessage('');
            setDisplayAfterLogOn(false);
            setIsActive(true);
            setShowLinkToHelp(false);
        } else if (selectedMessage) {
            if (timer) {
                clearInterval(timer);
                setTimer(null);
            }
            setNeedsValidation(false);
            setMessageDate(dateToStr(new Date(selectedMessage.MessageDate)));
            setExpireOnDate(selectedMessage.ExpireOnDate ? selectedMessage.ExpireOnDate : null);
            let date = new Date(selectedMessage.ExpireOnDate);
            setExpireOnTime(selectedMessage.ExpireOnDate ? pad(date.getUTCHours()) + ":" + pad(date.getUTCMinutes()) : '00:00');
            setMessage(selectedMessage.Message);
            setDisplayAfterLogOn(selectedMessage.DisplayAfterLogOn);
            setIsActive(selectedMessage.IsActive);
            setShowLinkToHelp(selectedMessage.ShowLinkToHelp);
        }
    }, [isAddMode]);

    return (
        <StyledMessageDetails>
            <WhiteBoard>
                <FormStringInput label='Date created' value={messageDate} disabled={true} inputStyle={{width:276}} style={{paddingTop:0}}></FormStringInput>
                <FormStringInput label='Username' value={props.user.UserName} disabled={true} inputStyle={{width:276}}></FormStringInput>
                <div style={{display:'flex'}}>
                    <FormDatePicker label='Expires on' value={new Date(expireOnDate)} onChange={(val) => setExpireOnDate(val)} style={{width:127}} validated={needsValidation && expireOnDate === null ? false : undefined} disabled={!selectedMessage && !isAddMode} ></FormDatePicker>
                    <FormStringInput label='Expire on (time)' value={expireOnTime} onChange={(val) => setExpireOnTime(val)} disabled={!selectedMessage && !isAddMode} validated={needsValidation && (expireOnTime === '' || !expireOnTime.includes(":")) ? false : undefined} inputStyle={{width:134}} style={{marginLeft:15}}></FormStringInput>
                </div>
                <FormStringTextArea label='Message' value={message} onChange={(val) => setMessage(val)} disabled={!selectedMessage && !isAddMode} validated={needsValidation && message === '' ? false : undefined} inputStyle={{width:276, height:100}}></FormStringTextArea>

                <FormCheckBoxWithRightLabel label='Display after logon' checked={displayAfterLogOn} disabled={!isAddMode && !selectedMessage} onCheck={(val) => setDisplayAfterLogOn(val)}></FormCheckBoxWithRightLabel>
                <FormCheckBoxWithRightLabel label='Is active' checked={isActive} disabled={!isAddMode && !selectedMessage} onCheck={(val) => setIsActive(val)}></FormCheckBoxWithRightLabel>
                <FormCheckBoxWithRightLabel label='Show link to main system help' checked={showLinkToHelp} disabled={!isAddMode && !selectedMessage} onCheck={(val) => setShowLinkToHelp(val)}></FormCheckBoxWithRightLabel>
            </WhiteBoard>
            <div>
                <PrimaryButton caption='Save changes' isLoading={isSaving} onClick={() => onSaveChanges()} style={{width:150, float:'right'}}></PrimaryButton>
            </div>
        </StyledMessageDetails>
    )
}

export default MessageDetails;